import {
  DEFAULT_EMPTY_ADDRESS_OBJECT,
  DEFAULT_EMPTY_CONTACT_PERSON_OBJECT,
} from '@/modules/base/util/constants'
import CustomerModel from '@/modules/customer/model/customer-model'

// actions
const SET_CUSTOMER_FORM_ERRORS = 'SET_CUSTOMER_FORM_ERRORS'
const ACTION_PREFIX = 'customer/edit'
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const OPEN_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/openAddressFormModal`
const CLOSE_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/closeAddressFormModal`
const SET_SELECTED_ADDRESS = `${ACTION_PREFIX}/setSelectedAddress`
const SET_SELECTED_CONTACT_PERSON = `${ACTION_PREFIX}/setSelectedContactPerson`
const OPEN_CONTACT_PERSON_MODAL = `${ACTION_PREFIX}/openContactPersonModal`
const CLOSE_CONTACT_PERSON_MODAL = `${ACTION_PREFIX}/closeContactPersonModal`
const OPEN_PAY_CONDITIONS_MODAL = `${ACTION_PREFIX}/openPayConditionsModal`
const CLOSE_PAY_CONDITIONS_MODAL = `${ACTION_PREFIX}/closePayConditionsModal`
const OPEN_DELIVERY_CONDITIONS_MODAL = `${ACTION_PREFIX}/openDeliveryConditionsModal`
const CLOSE_DELIVERY_CONDITIONS_MODAL = `${ACTION_PREFIX}/closeDeliveryConditionsModal`

const FINISH_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/finishAddressFormModal`
const ABORT_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/abortAddressFormModal`

// reducer
const initialState = {
  customer: new CustomerModel(),
  selectedAddress: DEFAULT_EMPTY_ADDRESS_OBJECT,
  selectedContactPerson: DEFAULT_EMPTY_CONTACT_PERSON_OBJECT,
  addressFormModalOpen: false,
  contactPersonModalOpen: false,
  payConditionModalOpen: false,
  deliveryConditionModalOpen: false,
  errors: {},
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CUSTOMER_FORM_ERRORS: {
      const { errors } = action
      return Object.assign({}, state, {
        errors,
      })
    }

    case OPEN_ADDRESS_FORM_MODAL: {
      const { selectedAddress = state.selectedAddress } = action
      return {
        ...state,
        selectedAddress,
        addressFormModalOpen: true,
      }
    }

    case CLOSE_ADDRESS_FORM_MODAL: {
      return {
        ...state,
        selectedAddress: DEFAULT_EMPTY_ADDRESS_OBJECT,
        addressFormModalOpen: false,
      }
    }

    case SET_SELECTED_ADDRESS: {
      const { selectedAddress = state.selectedAddress } = action
      return {
        ...state,
        selectedAddress,
        addressFormModalOpen: false,
      }
    }

    case SET_SELECTED_CONTACT_PERSON: {
      const { selectedContactPerson = state.selectedContactPerson } = action
      return {
        ...state,
        selectedContactPerson,
      }
    }

    case OPEN_CONTACT_PERSON_MODAL: {
      const { selectedContactPerson = state.selectedContactPerson } = action
      return {
        ...state,
        selectedContactPerson,
        contactPersonModalOpen: true,
      }
    }

    case CLOSE_CONTACT_PERSON_MODAL: {
      return {
        ...state,
        selectedContactPerson: DEFAULT_EMPTY_CONTACT_PERSON_OBJECT,
        contactPersonModalOpen: false,
      }
    }

    case OPEN_PAY_CONDITIONS_MODAL: {
      return {
        ...state,
        payConditionModalOpen: true,
      }
    }

    case CLOSE_PAY_CONDITIONS_MODAL: {
      return {
        ...state,
        payConditionModalOpen: false,
      }
    }

    case OPEN_DELIVERY_CONDITIONS_MODAL: {
      return {
        ...state,
        deliveryConditionModalOpen: true,
      }
    }

    case CLOSE_DELIVERY_CONDITIONS_MODAL: {
      return {
        ...state,
        deliveryConditionModalOpen: false,
      }
    }

    case RESET_STATE: {
      return initialState
    }

    default:
      return state
  }
};

export const setCustomerFormErrors = (errors) => {
  return {
    type: SET_CUSTOMER_FORM_ERRORS,
    errors,
  }
}

// action creators
export const openAddressFormModal = (selectedAddress) => ({
  type: OPEN_ADDRESS_FORM_MODAL,
  selectedAddress,
})

export const closeAddressFormModal = () => ({
  type: CLOSE_ADDRESS_FORM_MODAL,
})

export const openContactPersonModal = (selectedContactPerson) => ({
  type: OPEN_CONTACT_PERSON_MODAL,
  selectedContactPerson,
})

export const setSelectedAddress = (selectedAddress) => ({
  type: SET_SELECTED_ADDRESS,
  selectedAddress,
})

export const setSelectedContactPerson = (selectedContactPerson) => ({
  type: SET_SELECTED_CONTACT_PERSON,
  selectedContactPerson,
})

export const closeContactPersonFormModal = () => ({
  type: CLOSE_CONTACT_PERSON_MODAL,
})

export const openPayConditionsModal = () => ({
  type: OPEN_PAY_CONDITIONS_MODAL,
})

export const closePayConditionsModal = () => ({
  type: CLOSE_PAY_CONDITIONS_MODAL,
})

export const openDeliveryConditionsModal = () => ({
  type: OPEN_DELIVERY_CONDITIONS_MODAL,
})

export const closeDeliveryConditionsModal = () => ({
  type: CLOSE_DELIVERY_CONDITIONS_MODAL,
})

export const finishAddressFormModal = () => ({
  type: FINISH_ADDRESS_FORM_MODAL,
})

export const abortAddressFormModal = () => ({
  type: ABORT_ADDRESS_FORM_MODAL,
})

export const resetState = () => ({
  type: RESET_STATE,
})
